export default __webpack_public_path__ + "018871830f928a22cffc9937652902bd.svg";